// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"236":"44996d18714c6a275bb5","311":"5321870315d13da25c46"}[chunkId] + ".css";
};